import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function heading(): ComponentStyle {
  return {
    componentName: 'heading',
    baseStyle: {
      fontWeight: 600
    }
  };
}
